export default {
  ERROR__CLIENT_ID_REQUIRED:
    "Connection lost. Refresh the page, or wait before refreshing again— it should come back shortly.",
  ERROR__CLIENT_ID_REQUIRED__TITLE: "Pardon the interruption",
  ERROR__ROUTER_ID_NOT_FOUND:
    "Connection lost. Refresh the page, or wait before refreshing again— it should come back shortly.",
  ERROR__ROUTER_ID_NOT_FOUND__TITLE: "Pardon the interruption",
};
